import Chip from "@mui/material/Chip";

export const CREDIT_BAND_STYLES = {
	NEW: { backgroundColor: "#e3f2fd", color: "#1565c0" },
	EXCELLENT: { backgroundColor: "#e8f5e9", color: "#1b5e20" },
	GOOD: { backgroundColor: "#e8f5e9", color: "#2e7d32" },
	FAIR: { backgroundColor: "#fff8e1", color: "#f57f17" },
	POOR: { backgroundColor: "#ffebee", color: "#c62828" },
};

export const formatCreditBand = (band) => {
	if (!band) return "";
	const text = String(band).toLowerCase();
	return text.charAt(0).toUpperCase() + text.slice(1);
};

const fallbackChipSx = {
	backgroundColor: "#f5f5f5",
	color: "text.secondary",
};

export function CreditScoreFlag({ creditScore, size = "small", showLabel = false }) {
	const band = creditScore?.band;
	const score = creditScore?.score;
	const bandText = formatCreditBand(band);
	const label = creditScore
		? `${showLabel ? "Score " : ""}${score}${bandText ? ` · ${bandText}` : ""}`
		: showLabel
			? "Score —"
			: "—";

	return (
		<Chip
			size={size}
			label={label}
			sx={{
				fontWeight: 700,
				...(CREDIT_BAND_STYLES[String(band || "").toUpperCase()] || fallbackChipSx),
			}}
		/>
	);
}

export function RbPointsFlag({ points = 0, size = "small", showLabel = false }) {
	const value = points ?? 0;
	return (
		<Chip
			size={size}
			label={showLabel ? `RB points ${value}` : value}
			sx={{ fontWeight: 700, backgroundColor: "#fff3e0", color: "#e65100" }}
		/>
	);
}
